import { AttachmentForm } from 'Components/_NewElements/GeneralForms/AttachmentsForm';
import ConfirmationDialog from 'Components/ConfirmationDialog';
import InputHandler from 'Components/InputHandler';
import { dateFromPartial, isPartialDate, nowPartialDate } from 'neuro-utils';
import React from 'react';
import { useIntl } from 'react-intl';
import { actions } from 'Store/documents/actions';
import { useAppDispatch } from 'Store/index';

const AddNewDialog = ({ newAttachments, setNewAttachments, handleFileChange, fileType }: IAddNewDialog) => {
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  const dispatch = useAppDispatch();

  const [date, setDate] = React.useState<PartialDate>(nowPartialDate());
  const [loading, setLoading] = React.useState<boolean>(false);

  return (
    <ConfirmationDialog
      open={!!newAttachments}
      fullWidth={false}
      text={
        <div style={{ minWidth: '40rem' }}>
          {newAttachments && (
            <AttachmentForm
              fm={fm}
              attachmentData={newAttachments}
              handleFileChange={handleFileChange}
              allowedTypes={['.pdf']}
              attachmentLimit={1}
            />
          )}
          <div style={{ display: 'flex', marginTop: '3rem', alignItems: 'center' }}>
            <div style={{ marginRight: '2rem', fontSize: '1.6rem' }}>{fm('general.date')}</div>
            <InputHandler
              editing
              type="PartialDate"
              name="date"
              formData={{
                document: { date },
                onChange: values => {
                  const value = values['date'];
                  isPartialDate(value) && setDate(value);
                },
              }}
              isNotCancellable
            />
          </div>
        </div>
      }
      cancel={{
        callback: e => {
          e.stopPropagation();
          setNewAttachments(null);
        },
      }}
      confirm={{
        disabled: !((newAttachments ?? []).length > 0),
        text: 'general.accept',
        loading: loading,
        callback: async e => {
          e.stopPropagation();
          if (!newAttachments) return;
          setLoading(true);
          const filePromises = newAttachments.map(file => {
            const dateJS = dateFromPartial(date);
            return dispatch(actions.postNewFile(file, file.name, dateJS.toISOString(), fileType));
          });

          await Promise.all(filePromises).then(() => {
            setLoading(false);
            setNewAttachments(null);
          });
        },
      }}
    />
  );
};

interface IAddNewDialog {
  newAttachments: File[] | null;
  setNewAttachments: (files: File[] | null) => void;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fileType: string;
}

export default AddNewDialog;
